import { Button, ButtonGroup, ButtonVariant, Intent, Tag } from "@blueprintjs/core"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"
import { __ } from "src/libs/utilities"
import Scalar from "src/libs/scalars/scalars/Scalar"
import { ANIMATED_DELAY_VALUE } from "../../data/landin_scalars"
import { ANIMATE_DELAY } from "src/libs/interfaces/animated"

/* Protopia Ecosystem component */ 
const AnimatedDelayScalar = (props: ICompositeWidgetProps): JSX.Element => { 
    return <>
        <Scalar 
            subtitle={ props.title }
            value={props.value}
            editable={props.editable}
            notClear
            enabledForm={
                <AnimatedDelayScalarEnabled 
                    {...props} 
                    onChange={(value: any, field: string, dop: any) => {
                        if( props.onChange ) {
                            props.onChange( value, field,dop )
                        }
                    }}
                />
            }  
            desabledForm={<AnimatedDelayScalarDisable {...props} />} 
            subMenus={props.subMenus}
            onSubMenu={props.onSubmenu}  
            
        />
    </>
}
const AnimatedDelayScalarEnabled = (props: ICompositeWidgetProps): JSX.Element => {
    const onChange = (value: string | number) => { 
        if(props.onChange) {
            props.onChange(value, props.dataName, "" )
        }
    }
    return !props.value && props.noDefault
        ?
        <></>
        :
        <div className='pl-3'>
            <ButtonGroup>
                {
                    [ 0, 1, 2, 3, 4, 5, 6 ].fill(0).map( (_, i) => {
                        const variant = props.value == i ? ButtonVariant.SOLID : ButtonVariant.MINIMAL
                        const intent  = props.value == i ? Intent.SUCCESS : Intent.NONE
                        return <Button key={i} variant={ variant } intent={intent} onClick={() => onChange(i)}>
                            <div className="small">
                                { i + 1 }
                            </div>
                        </Button>
                    } )
                }
                <Button 
                    variant={ props.value === ANIMATE_DELAY.WATERFALL ? ButtonVariant.SOLID : ButtonVariant.MINIMAL}
                    intent={ props.value === ANIMATE_DELAY.WATERFALL ? Intent.SUCCESS : Intent.NONE }
                    onClick={() => onChange( ANIMATE_DELAY.WATERFALL )}
                >
                    <div className="small" >
                        {__(ANIMATE_DELAY.WATERFALL)}
                    </div>
                </Button>
            </ButtonGroup>
            <div className="letter-spacing-1 small mt-2 ml-3 opacity_5">
                {
                    props.value === ANIMATE_DELAY.WATERFALL
                        ?
                        __( "Elements appear in order with equal delay" )
                        :
                        `${ ANIMATED_DELAY_VALUE[ "VALUE_" + ( props.value ).toString() as any ] } ${__("msec")}` 
                }
            </div>
        </div>
}

const AnimatedDelayScalarDisable = (props: ICompositeWidgetProps): JSX.Element => {
    return <Tag >
        { __( props.value) || `${ANIMATED_DELAY_VALUE[ "VALUE_" + ( 0 ).toString() as any  ]} ${ __("ms") }` }
    </Tag>
}
export default AnimatedDelayScalar